<template>
  <v-list dense class="category-tree">
    <v-list-item dense class="hidden-md-and-up justify-end">
      <v-list-item-title class="font-weight-bold">
        {{ $t("categories.shopTitle") }}
      </v-list-item-title>
      <v-list-item-action @click.prevent.stop="drawerLeft = !drawerLeft">
        <v-icon>$close</v-icon>
      </v-list-item-action>
    </v-list-item>
    <v-list-group
      v-for="category in allCategories"
      :key="category.categoryId"
      class="category1"
      :class="[
        {
          'category-custom': category.isCustom
        },
        `category-${category.categoryId}`
      ]"
      append-icon=""
      @click="goToCategory(category)"
    >
      <template v-slot:prependIcon>
        <v-icon class="cat-1-icon" color="grey darken-2" small>$next</v-icon>
      </template>
      <template v-slot:activator>
        <v-list-item-title
          class="category-1-title"
          :style="{ color: $ebsn.meta(category, 'category_info.COLOR') }"
        >
          <router-link
            :to="{ name: 'Category', params: { pathMatch: category.slug } }"
            event
          >
            {{ category.name }}
          </router-link>
        </v-list-item-title>
      </template>
      <template v-for="category2 in category.categories">
        <v-list-group
          v-model="subActive[category2.categoryId]"
          sub-group
          class="category2"
          v-if="category2.categories"
          :key="category2.categoryId"
        >
          <template v-slot:prependIcon>
            <v-icon class="cat-2-icon mr-0" color="grey darken-2" small
              >$next</v-icon
            >
          </template>
          <template v-slot:activator>
            <v-list-item
              @click="subToggle(category2.categoryId)"
              class="px-0"
              :to="{
                name: 'Category',
                params: { pathMatch: category2.slug }
              }"
            >
              <v-list-item-title
                class="category2-title"
                :style="{ color: $ebsn.meta(category2, 'category_info.COLOR') }"
              >
                {{ category2.name }}
              </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-for="category3 in category2.categories"
            :key="category3.categoryId"
            :to="{ name: 'Category', params: { pathMatch: category3.slug } }"
            color="grey lighten-2"
            class="category3"
          >
            <v-list-item-title
              :style="{ color: $ebsn.meta(category3, 'category_info.COLOR') }"
            >
              {{ category3.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else
          @click="subToggle(category2.categoryId)"
          link
          :to="{ name: 'Category', params: { pathMatch: category2.slug } }"
          color="grey lighten-2"
          class="category2 no-child"
          :key="category2.categoryId"
        >
          <v-list-item-title
            :style="{ color: $ebsn.meta(category2, 'category_info.COLOR') }"
            >{{ category2.name }}</v-list-item-title
          >
        </v-list-item>
      </template>
    </v-list-group>
    <v-list v-if="isCordova"><div class="bottom"></div></v-list>
  </v-list>
</template>
<script>
import deliveryReactive from "~/mixins/deliveryReactive";

import categoryService from "@/commons/service/categoryService";

import { mapState, mapActions, mapGetters } from "vuex";
import each from "lodash/each";

export default {
  name: "CategoryTree",
  // components: { CategoryBlock },
  mixins: [deliveryReactive],
  data() {
    return {
      expandedKeys: [],
      selectedKey: null,
      threeCategories: [],
      subActive: {},
      categoryOpened: null,
      firstLevelCategories: []
    };
  },
  computed: {
    ...mapState({
      categories: ({ category }) => category.categoryTree,
      storeDrawerLeft: state => state.app.drawerLeft
    }),
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    }),
    drawerLeft: {
      get() {
        return this.storeDrawerLeft;
      },
      set(value) {
        this.updatedDrawerLeft(value);
      }
    },
    allCategories() {
      let allCat = [];
      if (this.threeCategories?.children) {
        each(this.threeCategories.children, category => {
          category.isCustom = true;
        });
        allCat = allCat.concat(this.threeCategories.children);
      }
      if (this.categories) {
        allCat = allCat.concat(this.categories);
      }
      return allCat;
    }
  },
  methods: {
    subToggle(categoryId) {
      for (let i = 0; i < Object.keys(this.subActive).length; i++) {
        if (categoryId != Object.keys(this.subActive)[i]) {
          this.subActive[Object.keys(this.subActive)[i]] = false;
        }
      }
    },
    ...mapActions({
      reload: "category/loadCategoryTree",
      updatedDrawerLeft: "app/updatedDrawerLeft"
    }),
    async fetchCategory(cat) {
      let vm = this;
      if (vm.firstLevelCategories[cat.categoryId] != undefined) {
        vm.categoryOpened = vm.firstLevelCategories[cat.categoryId];
      } else {
        let result = await categoryService.getCategoryBySlug(cat.slug);
        vm.firstLevelCategories[cat.categoryId] = result;
        vm.categoryOpened = result;
      }
    },
    goToCategory(category) {
      this.categoryOpened = null;
      if (category.isCustom) {
        this.$router.push({
          name: "Category",
          params: { pathMatch: category.slug }
        });
      } else {
        this.fetchCategory(category);
      }
    },
    async getCategories() {
      try {
        this.threeCategories = await categoryService.getCategoryBySlug(
          "category-tree",
          false
        );
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.reload();
    this.getCategories();
  }
};
</script>
<style lang="scss">
.category-tree {
  // animazione prepend icon cat 1 e 2
  .category1.v-list-group.v-list-group--active {
    .v-list-item__icon.v-list-group__header__prepend-icon .v-icon.cat-1-icon {
      transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
    }
    .category2.v-list-group.v-list-group--sub-group.v-list-group--active {
      .v-list-item__icon.v-list-group__header__prepend-icon .v-icon.cat-2-icon {
        transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
      }
    }
  }
  .v-list-group {
    .v-list-item__icon.v-list-group__header__prepend-icon {
      min-width: 16px;
    }
  }

  .category-custom {
    font-weight: bold;
    text-transform: none !important;
  }

  .category2 {
    // &.v-list-group--sub-group .v-list-group__header {
    //   padding-left: 0px !important;
    // }
    .v-list-item__icon.v-list-group__header__prepend-icon {
      margin-right: 8px;
    }
  }

  a {
    color: inherit !important;
    text-decoration: inherit !important;
  }

  .category1 {
    .v-list-item__title {
      color: $text-color;
      overflow: display !important;
    }
    &.v-list-group--active {
      .v-list-item__title > a {
        font-weight: 700;
      }
    }
  }
  .category2 {
    &.v-list-group--sub-group .v-list-group__header {
      padding-left: 16px !important;
    }
    &.v-list-group--active {
      .category2-title {
        font-weight: 700;
      }
    }
    &.no-child {
      &.v-list-item--active {
        .v-list-item__title {
          font-weight: 700;
        }
      }
    }
  }
  .category3 {
    &.v-list-item {
      padding-left: 70px !important;
    }
    &.v-list-item--active {
      .v-list-item__title {
        font-weight: 700 !important;
      }
    }
  }
  .bottom {
    height: 100px;
  }
  .theme--light.v-list-item--active::before {
    opacity: 0;
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    // fix for mobile browser, because otherwise with browser's navigation bar opened last category of the tree is not visible
    padding-bottom: 100px;
  }
}
</style>
